module.exports = __webpack_public_path__ + "img/courier-ptc.55993534.svg";